var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    { attrs: { type: "card" } },
    [
      _c("p", { staticClass: "d2-mt-0" }, [
        _vm._v(
          "在下面的输入框输入任意字符后，切换到其它页面，再回到此页时输入框文字保留，证明被缓存"
        )
      ]),
      _c("el-input", {
        attrs: { placeholder: "input here" },
        model: {
          value: _vm.value,
          callback: function($$v) {
            _vm.value = $$v
          },
          expression: "value"
        }
      }),
      _c("p", [_vm._v("关闭标签页")]),
      _c(
        "el-button-group",
        [
          _c(
            "el-button",
            { on: { click: _vm.handleCloseCurrent } },
            [_c("d2-icon", { attrs: { name: "times" } }), _vm._v(" 当前 ")],
            1
          ),
          _c(
            "el-button",
            { on: { click: _vm.handleCloseLeft } },
            [
              _c("d2-icon", { attrs: { name: "arrow-left" } }),
              _vm._v(" 左侧 ")
            ],
            1
          ),
          _c(
            "el-button",
            { on: { click: _vm.handleCloseRight } },
            [
              _vm._v(" 右侧 "),
              _c("d2-icon", { attrs: { name: "arrow-right" } })
            ],
            1
          ),
          _c(
            "el-button",
            { on: { click: _vm.handleCloseOther } },
            [_vm._v(" 其它 "), _c("d2-icon", { attrs: { name: "times" } })],
            1
          ),
          _c(
            "el-button",
            { on: { click: _vm.closeAll } },
            [
              _vm._v(" 全部 "),
              _c("d2-icon", { attrs: { name: "times-circle" } })
            ],
            1
          )
        ],
        1
      ),
      _c("p", [_vm._v("刷新")]),
      _c(
        "el-button-group",
        [
          _c(
            "el-button",
            { on: { click: _vm.handleCleanCacheAndRefreshCurrent } },
            [
              _c("d2-icon", { attrs: { name: "refresh" } }),
              _vm._v(" 清空当前页缓存并刷新 ")
            ],
            1
          ),
          _c(
            "el-button",
            { on: { click: _vm.handleCleanCacheAndRefreshAll } },
            [
              _c("d2-icon", { attrs: { name: "refresh" } }),
              _vm._v(" 清空所有缓存并刷新 ")
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }